import {get, post} from './http';

// let ip = 'http://127.0.0.1:5000/'
// let ip = 'http://42.193.244.165:5000/'
let ip = 'https://www.sensevib.com/api/'
// 首页图表布局

// 获取天气
export function getWeather (lang, location) {
    console.log('https://devapi.qweather.com/v7/weather/now', {key: 'e377abeb8a0e4b759f3dff327a4bfc88',
        location: location, lang: lang})
    return get('https://devapi.qweather.com/v7/weather/now', {key: 'e377abeb8a0e4b759f3dff327a4bfc88',
        location: location, lang: lang})
}


//获取前300条数据
export function getInit_home() {
    return get(ip + 'init_home')
}


//获取前300条数据
export function getInit_freq(param) {
    return get(ip + 'init_freq', param)
}

//获取热力图初始数据
export function getInit_heat(param) {
    return get(ip + 'init_heat',param)

}


export function getNode_status() {
    return get(ip + 'status')

}

// 获取最新的设备信息
export function get_devices() {
    return get(ip + 'devices')
}

// 获取特定节点最大值
export function get_max(param) {
    return get(ip + 's_max',param)
}

// 获取最新的设备信息
export function get_all_v() {
    return get(ip + 'all_v')
}

// 地震信息
export function get_earthquake(stime, etime) {
    return get(`https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson&starttime=${stime}&endtime=${etime}&minlatitude=4&maxlatitude=54&minlongitude=72&maxlongitude=136`)
}

// 获取最新的设备信息
export function get_exits_date(node) {
    return get(ip + 'get_exits_date'+ `?node=${node}`)
}

// 获取丢包数量
export function get_loss(node) {
    return get(ip + 'get_loss'+ `?node=${node}`)
}

// 获取电池和信号数量
export function get_bs(node, mode='single') {
    if(mode==='single') {
        return get(ip + 'get_bs'+ `?node=${node}`)
    } else {
        return get(ip + 'get_bs'+ `?nodes=${node}`)
    }

}

// 获取版本号
export function get_version(node) {
    return get(ip + 'get_version'+ `?node=${node}`)
}

// 获取电压电流
export function get_voltage(node) {
    return get(ip+'get_voltage'+ `?node=${node}`)

}

// 获取同步信息
export function get_sync(node) {
    return get(ip+'get_sync'+ `?node=${node}`)
}

// 获取回归
export function get_fusion(node) {
    return get(ip+'get_fusion'+ `?node=${node}`)
}

// 登陆
export function user_login(authInfo) {
    return post(ip+'login', authInfo)
}

// 生成嵌入链接免登录 token
export function createEmbedToken(data) {
    return post(ip+'api/auth/embed-token', data)
}

// 获取页面的权限信息
export function get_pages_config() {
    return get(ip+'pages_config')
}


// 获取三维模型的权限信息
export function get_three_config() {
    return get(ip+'three_config')
}

// 获取节点的配置信息
export function getDeviceConf(mac) {
    return get(ip+`api/devcie_config/${mac}`)
}

// 发送指令
export function sendCommand(data) {
    return post(ip+'api/device_command', data)
}

// 发送指令
export function sendEvent(data) {
    return post(ip+'api/detect_event', data)
}


// 获取节点的数据
export function getData(params) {
    return get(ip+'api/pub/vdata', params)
}

// 获取节点的数据
export function get_geo_params() {
    return get(ip+'geo_params')
}



// WEBPACK FOOTER //
// ./src/api/index.js